module.exports = "/_next/static/images/beatgig-logo-256-6dfa392e99894e4f9e6b4d7245bd859e.png";